var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    { staticClass: "dd-right", attrs: { right: "" } },
    [
      _c(
        "template",
        { slot: "button-content" },
        [
          _c("v-gravatar", {
            staticClass: "img-avatar",
            attrs: { email: _vm.currentUserEmail, alt: _vm.currentUserEmail }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isAdminRole
        ? _c("b-dropdown-item", { attrs: { to: "/admin/users" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.ddAdmin) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(_vm._s(_vm.$t("HEADER.USERS")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("b-dropdown-item", { on: { click: _vm.logOut } }, [
        _c("div", {
          staticClass: "dd-icon",
          domProps: { innerHTML: _vm._s(_vm.svg.ddLogout) }
        }),
        _c("span", { staticClass: "dd-text" }, [
          _vm._v(_vm._s(_vm.$t("HEADER.LOGOUT")))
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449f32eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449f32eb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/micp/micpHeaderAccount.vue
// module id = 945
// module chunks = 2